import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { QueueItem } from 'components'

const GroupedItems = ({
  item,
  trackCount,
  title,
  message,
  isPlaying,
  selectedSong,
  onClickClose,
  onClickPlay,
  selectedHoverItem,
  setSelectedHoverItem,
  isIpadView,
  isHighlighted
}) => {
  const handleOnClickClose = (itemToClose, parent = null) => {
    if (parent && parent.songs.length === 1) {
      onClickClose(parent)
    } else {
      onClickClose(itemToClose)
    }
  }

  const handleOnClickPlay = (itemToPlay) => {
    onClickPlay(itemToPlay)
  }

  return (
    <>
      <QueueItem
        item={item}
        isReleaseItem={item.songs.length > 1}
        isHighlighted={isHighlighted}
        isPlaying={isPlaying}
        showPlayingIcon={isHighlighted}
        title={title}
        artist={message}
        onClickClose={() => handleOnClickClose(item)}
        onClickPlay={() => handleOnClickPlay(item)}
      />
    </>
  )
}

GroupedItems.propTypes = {
  item: PropTypes.object,
  trackCount: PropTypes.number,
  title: PropTypes.string,
  message: PropTypes.string,
  isHighlighted: PropTypes.bool,
  isPlaying: PropTypes.bool,
  selectedSong: PropTypes.object,
  onClickClose: PropTypes.func,
  onClickPlay: PropTypes.func,
  selectedHoverItem: PropTypes.object,
  setSelectedHoverItem: PropTypes.func,
  isIpadView: PropTypes.bool
}

export default GroupedItems
